import { render, staticRenderFns } from "./BtnNextStep.vue?vue&type=template&id=5176d932"
import script from "./BtnNextStep.vue?vue&type=script&lang=js"
export * from "./BtnNextStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports